<template>
  <el-select id="picker" size="small" v-model="occasionSelected" placeholder="Special Occasion?" @change="occasionChange">
    <el-option
      v-for="oc in occasions"
      :key="oc.value"
      :label="oc.label"
      :value="oc.value">
    </el-option>
  </el-select>
</template>

<script>

export default {
  name: 'occasionPicker',
  data() {
    return {
      occasions: [{
        value: "birthday",
        label: "Birthday",
      },{
        value: "anniversary",
        label: "Anniversary",
      },{
        value: "other",
        label: "Other"
      },{
        value: null,
        label: "No Occasion"
      }]
    }
  },
  computed: {
    occasionSelected: {
      get() {
        return this.$store.state.userInfo.occasion
      },
      set( val ) {
        this.$store.commit( 'userInfo/UPDATE_OCCASION', val )
      }
    }
  },
  methods: {
    occasionChange() {
      this.$emit( 'occasionChange', this.occasionSelected )
    }
  }
}

</script>

<style scoped lang="scss">
</style>